import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/voice/getList',
        method: 'post',
        data: data
    })
}

export function createVoiceTemplate(data) {
    return request({
        url: '/backend/voice/createVoiceTemplate',
        method: 'post',
        data: data
    })
}

export function deleteVoiceTemplate(data) {
    return request({
        url: '/backend/voice/deleteVoiceTemplate',
        method: 'post',
        data: data
    })
}

export function onlineVoiceTemplate(data) {
    return request({
        url: '/backend/voice/onlineVoiceTemplate',
        method: 'post',
        data: data
    })
}